<template>
  <div class="composition-pos-status-badges">
    <CompositionPosStatusBadge
      v-for="posState in posStates"
      :key="posState.status.key"
      :pos-types="posState.posTypes"
      :status="posState.status"
      :hide-icon="hideIcon"
    />
    <InstantlyPublishedHint
      :composition="composition"
      :relevant-pos-types="relevantPosTypes"
    />
  </div>
</template>

<script>
import CompositionPosStatusBadge from './CompositionPosStatusBadge.vue';
import {
  getAllCompositionPosStates,
  getAllCompositionPosStatesCombined,
} from 'commons/api/models/publishingCore/compositionPosStates';
import InstantlyPublishedHint from 'src/app/components/publishing/statusBadges/InstantlyPublishedHint.vue';

export default {
  name: 'CompositionPosStatusBadges',
  components: {
    InstantlyPublishedHint,
    CompositionPosStatusBadge,
  },
  props: {
    composition: {
      required: true,
      type: Object,
    },
    relevantPosStates: {
      type: Array,
    },
    relevantPosTypes: {
      type: Array,
    },
    hideIcon: {
      type: Boolean,
    },
  },
  data() {
    return {
      combine: true,
    };
  },
  computed: {
    posStates() {
      const posStates = getAllCompositionPosStates({
        composition: this.composition,
        relevantPosTypes: this.relevantPosTypes,
        relevantPosStates: this.relevantPosStates,
      });

      if (this.combine) {
        return getAllCompositionPosStatesCombined({
          composition: this.composition,
          relevantPosTypes: this.relevantPosTypes,
          relevantPosStates: this.relevantPosStates,
        });
      } else {
        return posStates.map((posState) => ({
          ...posState,
          posTypes: [posState.posType],
        }));
      }
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.composition-pos-status-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
</style>
